import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class BrandService {
  static getStockBrands() {
    throw new Error('Method not implemented.')
  }
  query

  constructor(query) {
    this.query = query
  }

  getBrands() {
    return RetailerApiClient.get('retailer-brands', {
      params: this.query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrandsInStock(query) {
    return RetailerApiClient.get('brands', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrandById(brandId) {
    return RetailerApiClient.get('retailer-brands/' + brandId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrandsByCategory(categoryId) {
    return RetailerApiClient.get('categories/' + categoryId + '/brands')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getUnbrandedBrand() {
    return RetailerApiClient.get('unbranded-brand')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  attachBrand(params) {
    return RetailerApiClient.post('retailer-brands', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  removeBrand(categoryId, brandId) {
    return RetailerApiClient.delete('retailer-brands/' + brandId + '/categories/' + categoryId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getRetailerStockBrandsByProduct(productId, shortSaleBrands = false) {
    let additionalQuery = shortSaleBrands === true ? '?only_short_sale_brands=true' : ''
    return RetailerApiClient.get('stock/' + productId + '/retailer-brands' + additionalQuery)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrandsByProduct(productId, salesChannelId) {
    return RetailerApiClient.get('products/' + productId + '/brands', {
      params: {
        sales_channel_id: salesChannelId
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getAddableBrands(productId, salesChannelId) {
    return RetailerApiClient.get('products/' + productId + '/addable-brands', {
      params: {
        sales_channel_id: salesChannelId
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  getBrandsByUsingProduct(params) {
    return RetailerApiClient.post('products/' + params.product_id + '/meta', { items: params.items })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
